import { createElement } from "@wordpress/element";
import PropTypes from "prop-types";
import { createContext } from "@wordpress/element";
const defaultRootContext = {
  isRtl: false
};
export const RootContext = createContext(defaultRootContext);

/**
 * @param {JSX.node} children The React children.
 * @param {{ isRtl: boolean }} context The root context value.
 * @returns {JSX.Element} The Root component.
 */
const Root = ({
  children,
  context = {},
  ...props
}) => {
  return createElement(RootContext.Provider, {
    value: {
      ...defaultRootContext,
      ...context
    }
  }, createElement("div", {
    className: "nfd-root",
    ...props
  }, children));
};
Root.propTypes = {
  children: PropTypes.node.isRequired,
  context: PropTypes.shape({
    isRtl: PropTypes.bool
  })
};
export default Root;